import React, {useEffect, useState} from 'react';
import {Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack} from '@mui/material';
import api from "../../../services/api";
import CircularProgress from "@mui/material/CircularProgress";
import SuccessGif from '../../../assets/icons/success.gif';
import WarningGif from '../../../assets/icons/warning.gif';
import Avatar from "@mui/material/Avatar";
import Lottie from "lottie-react";
import loadingAnimation from "../../../assets/icons/loading.json";
import successAnimation from "../../../assets/icons/success.json";
import errorAnimation from "../../../assets/icons/error.json";
import {LoadingButton} from "@mui/lab";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  data: any;
}

const ActivityServiceStructureDialog: React.FC<ConfirmDialogProps> = ({
                                                       open,
                                                       onClose,
                                                       onConfirm,
                                                       data,
                                                     }) => {

  const [state, setState] = useState<"loading" | "success" | "error">("loading");

  const fetchCheckStructure = async () => {

    setState("loading");
      api.get(`/activity-reservations/structure/${data?.activity_reservation?.id}/${data?.service?.id}`).then((result: any) => {
      setState(result?.data?'success':'error');
    }).catch(()=>{

    }).finally(()=>{

    });
  }

  const getAnimation = () => {
    if (state === "loading") return loadingAnimation;
    if (state === "success") return successAnimation;
    return errorAnimation;
  };

  const getTitle = () => {
    if (state === "loading") return "Please wait...";
    if (state === "success") return "Successfully checked";
    return "This Service Reservation is not in the Activity-Service structure. Do you want to continue?";
  };

  useEffect(() => {
    fetchCheckStructure();
  }, []);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Check Activity - Service Structure</DialogTitle>
      <DialogContent>
        <Typography variant="body1">Let's check whether the service you want to add complies with the structure of the activity.</Typography>

        <Stack alignItems={'center'}>


          <Lottie
            animationData={getAnimation()}
            loop={state === "loading"}
            style={{ width: 100, height: 100, margin: "0 auto" }}
          />
          <Typography variant="body1" sx={{ mt: 2 }}>
            {getTitle()}
          </Typography>

        </Stack>

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>CANCEL</Button>
        <LoadingButton
          loading={state==='loading'}
          variant="contained"
          color="primary"
          onClick={()=>{
            onConfirm();
            setState('loading');
          }}
          autoFocus>
          YES
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ActivityServiceStructureDialog;
